/** UPI VPA, e.g. shritiffins@okhdfcbank */
export const VPA_RE = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z][a-zA-Z0-9.-]{1,63}$/;

/**
 * UPI deep link (NPCI "upi://pay" intent) used for the dynamic QR on screen and on receipts.
 * The cashier still confirms receipt manually — there is no gateway callback in Phase 2.
 */
export function buildUpiUri({ vpa, payeeName, amountPaise, note, ref }) {
  if (!VPA_RE.test(vpa ?? '')) throw new Error('Invalid UPI ID');
  const params = [
    ['pa', vpa],
    ['pn', (payeeName ?? '').slice(0, 50)],
    ['am', (amountPaise / 100).toFixed(2)],
    ['cu', 'INR'],
  ];
  if (note) params.push(['tn', String(note).slice(0, 50)]);
  if (ref)
    params.push([
      'tr',
      String(ref)
        .replace(/[^A-Za-z0-9]/g, '')
        .slice(0, 35),
    ]);
  return `upi://pay?${params.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')}`;
}
